module.exports = __webpack_public_path__ + "static/img/20200414153110.b4dc8ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20200414153110.jpg
// module id = Za1a
// module chunks = 1